export default "__VITE_ASSET__BAxy3qGM__"